import { render, staticRenderFns } from "./buttonCsvCliente.vue?vue&type=template&id=ce12bd2a&scoped=true&"
import script from "./buttonCsvCliente.vue?vue&type=script&lang=js&"
export * from "./buttonCsvCliente.vue?vue&type=script&lang=js&"
import style0 from "./buttonCsvCliente.vue?vue&type=style&index=0&id=ce12bd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce12bd2a",
  null
  
)

export default component.exports